import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  UpdateEmissionFactorDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_EMISSION_FACTORS } from "../domain";

import { emissionFactorsApi } from "@api/services";
import { ACTION_GET_EMISSION_FACTORS, roleGuard } from "@api";

export const ACTION_UPDATE_EMISSION_FACTOR = "UPDATE_EMISSION_FACTOR";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateEmissionFactorRequest = {
  emissionFactorId: string;
  dto: UpdateEmissionFactorDto;
};

const updateEmissionFactor = async (
  req: UpdateEmissionFactorRequest,
): Promise<void> => {
  await emissionFactorsApi.emissionFactorsControllerUpdateEmissionFactor(
    req.emissionFactorId,
    req.dto,
  );
};

export const useUpdateEmissionFactor = (
  user: UserProfileDto | null,
): {
  updateEmissionFactor: UseMutateFunction<
    void,
    unknown,
    UpdateEmissionFactorRequest,
    unknown
  >;
  updateEmissionFactorEnabled: boolean;
  isSuccessUpdateEmissionFactor: boolean;
  isPendingUpdateEmissionFactor: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_EMISSION_FACTORS, ACTION_UPDATE_EMISSION_FACTOR],
    mutationFn: enabled ? updateEmissionFactor : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_EMISSION_FACTORS, ACTION_GET_EMISSION_FACTORS],
      });
    },
  });

  return {
    updateEmissionFactor: mutate,
    updateEmissionFactorEnabled: enabled,
    isSuccessUpdateEmissionFactor: isSuccess,
    isPendingUpdateEmissionFactor: isPending,
  };
};
